module.exports = __webpack_public_path__ + "components/flag/static/square/io-5aaf0ea58ff33eb16d10b0eac07dff4f.svg";